import { some } from "lodash/fp";
// a list of bot identifiers, we want to avoid firing segment track events for bots
export const knownBots = [
  "Baiduspider",
  "Googlebot",
  "Applebot",
  "SpeedCurve",
  "Pinterestbot",
  "vintagio-bot",
  "PetalBot",
  "yandex.com/bots",
  "SemrushBot",
  "Twitterbot",
  "Storebot",
  "KlarnaBot",
  "WatcherBot",
];
export const isKnownBot = ({
  navigator: { userAgent },
}: { navigator: Pick<Navigator, "userAgent"> } = window) =>
  window?.isVerifiedBot === true ||
  some((bot) => userAgent.toLowerCase().includes(bot.toLowerCase()), knownBots);
